export default "__VITE_ASSET__BOMPAsRh__"